import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "product-chat-widget" */ './ProductFaq'));
